import React from 'react'
import { Modal } from 'react-bootstrap'
import './ConfirmationModal.css'

type ConfirmationModalProps = {
  show: boolean
  onHide: () => void
  title: string | React.ReactElement
  body: JSX.Element
  footer: JSX.Element
  size?: 'sm' | 'lg' | 'xl' | 'md'
  className?: string
  backdropClassName?: string
  headerClassName?: string
  backdrop?: boolean | 'static'
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  title,
  body,
  footer,
  size = 'sm',
  className,
  backdropClassName,
  headerClassName,
  backdrop,
}) => {
  const headerClasses = ['bg-custom3', headerClassName]
    .filter(Boolean)
    .join(' ')
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      {...(size !== 'md' ? { size } : {})}
      {...(backdrop !== undefined ? { backdrop } : {})}
      backdropClassName={backdropClassName}
      className={`confirmation-modal ${className || ''}`}
    >
      <Modal.Header className={headerClasses} closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>{footer}</Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
